<template>
    <v-dialog v-model="dialog" width="500" persistent>
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">{{ editId ? 'ویرایش رویداد' : 'رویداد جدید' }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon="close" variant="text" @click="dialog = false"></v-btn>
            </v-toolbar>
            <v-form @submit.prevent="formRef?.isValid ? submit() : ''" ref="formRef" class="px-6 pt-4">
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="form.name"
                ></v-text-field>
                <switch-input v-model="form.type" label="نحوه ثبت رویداد" color="" true-label="API" false-label="دستی" v-if="!editId"></switch-input>
                <v-card-actions class="pb-4 px-6">
                    <v-btn color="success" variant="flat" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="dialog = false" variant="text" :disabled="loading">بستن</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script setup>
const initialForm = {
    name: null,
    type: false
};
const dialog = ref(false);
const editId = ref(false);
const loading = ref(false);
const form = reactive({...initialForm});
const formRef = useTemplateRef('formRef');
const api = useApi();
const toast = useToastStore();
const system = useSystemStore();
const emit = defineEmits(['done']);
function openDialog(editItem = false) {
    if (formRef.value)
        formRef.resetValidation();
    if (editItem) {
        editId.value = editItem.id;
        form.name = editItem.name;
    } else {
        editId.value = false;
        Object.assign(form, initialForm);
    }
    dialog.value = true;
}
async function submit() {
    loading.value = true;
    const res = editId.value ? await api.customerEventTypeUpdate(editId.value, { name: form.name }) : await api.customerEventTypeStore(form);
    if (res && ['CREATED', 'UPDATED'].includes(res.status)) {
        toast.success(res.message);
        emit('done');
        system.setSystemDefaults(true);
        dialog.value = false;
    }
    loading.value = false;
}
defineExpose({openDialog})
</script>
